import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-scrollable',
  templateUrl: './scrollable.component.html',
  standalone: true,
  imports: [CommonModule],
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScrollableComponent {
  constructor() {}

  private _scrollBarWidth = '17px';
  @Input() width: string = '';

  @Input() height: string = '400px';

  get verticalScrollStyle() {
    const val: { [key: string]: any } = {};
    if (this.width) val['overflow'] = 'auto scroll';
    else val['overflow-y'] = 'scroll';

    val['max-height'] = this.height;
    val['--scrollbar-width'] = this._scrollBarWidth;
    return val;
  }

  get widthStyle() {
    const val: { [key: string]: any } = {};
    if (this.width) {
      val['width'] = this.width;
      val['min-width'] = '100%';
    }
    return val;
  }

  get horizontalScrollStyle() {
    const val: { [key: string]: any } = {};
    val['overflow'] = 'auto hidden';
    val['--scrollbar-width'] = this._scrollBarWidth;
    return val;
  }
}
